module.exports = __webpack_public_path__ + "img/object-sliced4.9c76846c.svg";